import { Box, Button, Text, useToast, VStack, HStack, Flex } from "@chakra-ui/react";

import FileListWithBrowseOrUpload from "../components/FileListWithBrowseOrUpload";
import { RightSidebarHeader } from "components/Layout/RightSidebarWidget";
import { useQueryClient } from "react-query";
import { useSelector } from "react-redux";
import { useState } from "react";
import { postSourcesUpdate, postQuestionsAnswerJob } from "api/ai/ai.service";
import { showSuccessToast } from "utils";
import { getFolderForRound, KB_FOLDER } from "api/common/fileinfo";
import { apiAddToFolders } from "api/common/fileinfo.service";
import { useNavigate } from "react-router-dom";
import { routes } from "config/paths";
import { useRightSidebar } from "context/RightSidebarContext";

/**
 * File upload and management panel
 * @param tables string[] - The tables to show: ACTIVE, OTHER, ARCHIVED, KB (see SourcesListPanel)
 */
export default function SourcesUploadRSidebar({ activeFiles, hideAIReviewButton, tables }) {
  const queryClient = useQueryClient();
  const roundSelector = useSelector((state) => state.issbRound);
  const { doClose } = useRightSidebar();

  /** @type {FileInfo[]} */
  const [fileInfoList, setFileInfoList] = useState([]);

  let folder = getFolderForRound(roundSelector?.selectedRound?.id);
  // HACK: KB upload?
  if (tables?.includes(KB_FOLDER) && tables.length === 1) {
    folder = KB_FOLDER;
  }

  const onFileInfoListChange = (newFileInfoList) => {
    console.log("onFileInfoListChange", newFileInfoList);
    queryClient.invalidateQueries("fileinfoService.list");
    const newFiles = newFileInfoList.filter((f) => !fileInfoList.includes(f));
    setFileInfoList(newFileInfoList);
    // add to the round
    newFiles.forEach((f) => apiAddToFolders(f.id, folder));
    // request AI analysis of new files
    newFiles.forEach((f) => postSourcesUpdate([f.id], true));
  };

  return (
    <Box id="SourcesUploadRSidebar" h="full" display="flex" flexDirection="column">
      <RightSidebarHeader>Upload Additional Documents</RightSidebarHeader>

      <Box m={4}>
        <FileListWithBrowseOrUpload
          folder={folder}
          tags={["ISSB"]}
          fileInfoList={fileInfoList}
          onFileInfoListChange={onFileInfoListChange}
          canBrowse={false}
        />
      </Box>

      {/* spacer to push buttons to the bottom */}
      <Box flexGrow={1}></Box>

      {/*{unprocessedFiles?.length ? (*/}
      {/*  <Button mt={4} variant="secondary" onClick={handleProcessFiles} isDisabled={isFilesProcessing}>*/}
      {/*    Process {unprocessedFiles.length} documents*/}
      {/*  </Button>*/}
      {/*) : null}*/}

      <Flex w="100%" gap={4} mt={4}>
        <Button variant="secondary" onClick={doClose} flex="1">
          Close
        </Button>
        {/*{!hideAIReviewButton && (*/}
        {/*  <Button variant="primary" onClick={gotoAIReview} flex="1">*/}
        {/*    Run AI Review*/}
        {/*  </Button>*/}
        {/*)}*/}
      </Flex>
    </Box>
  );
}
